import { Link } from "react-router-dom";

export default function Breadcrumb({ items }) {
    return (
        <nav
            aria-label="breadcrumb"
            className="w-full rounded-lg md:px-20 py-2 mb-6"
        >
            <ol className="flex flex-wrap items-center space-x-2 rtl:space-x-reverse text-sm">
                {items.map((item, idx) => (
                    <li
                        key={idx}
                        className={`flex items-center ${item.active ? "text-gray-500 hover:text-gray-800" : "text-gray-500 hover:text-gray-800"
                            }`}
                        aria-current={item.active ? "page" : undefined}
                    >
                        {item.active ? (
                            <span>{item.label}</span>
                        ) : (
                            <Link to={item.to} className="transition-colors duration-200">
                                {item.label}
                            </Link>
                        )}

                        {/* جداکننده بین آیتم‌ها به جز آخرین */}
                        {idx < items.length - 1 && (
                            <span className="mx-2 text-gray-400">{`>`}</span>
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    );
}
